import * as React from 'react';
import { hydrate } from '../../core/components/hydrate.js';
import { ResearchTurn } from '../../feedback/components/ResearchTurn.js';
import type { ResearchQuery } from '../../feedback/components/ResearchTurn.js';

interface LandingResearchTurnProps {
    turn: ResearchQuery;
}

/**
 * The landing page's Ask preview, hydrated so its citation badges show the cited feedback on
 * hover exactly as they do on the Research page. Citations are hover-only (`linkCitations`
 * false): there is no real org behind the preview, so a link would lead a visitor to a login wall.
 */
export const LandingResearchTurn: React.FC<LandingResearchTurnProps> & { ScriptName: string; URLPath: string } = ({
    turn,
}) => (
    <ResearchTurn turn={turn} turnIndex={0} orgSlug="your-org" linkCitations={false} />
);

LandingResearchTurn.ScriptName = 'LandingResearchTurn';
LandingResearchTurn.URLPath = 'home/components/LandingResearchTurn';
hydrate(LandingResearchTurn);
